import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class PurchasePlanningNavService {
  #loadingIndicator$ = new BehaviorSubject(false);
  loadingIndicator$ = this.#loadingIndicator$.asObservable();

  setLoadingIndicator(value: boolean) {
    this.#loadingIndicator$.next(value);
  }
}
